import { Text, TextDescriptionVariant } from './index'
import { Text as BrowserText, TextDescriptionVariant as BrowserTextDescriptionVariant } from '../browser-text'

export const getPlatformSpecificText = (isWeb: boolean) => {
  return {
    Text: isWeb ? BrowserText : Text,
    TextDescriptionVariant: isWeb ? BrowserTextDescriptionVariant : TextDescriptionVariant,
  }
}
